const getCameraFromSubscription = (subscription, uuid) => {
  return subscription?.location?.system?.cameras.filter(
    (camera) => camera.uuid === uuid
  )?.[0];
};

export { getCameraFromSubscription };
